<template>
    <vue-scroll>
        <div class="float-right mt-10">
            <el-input
                placeholder="Search All Orders..."
                style="width: 250px"
                v-model="filter.search"
            />
        </div>
        <div class="clearfix"></div>
        <outstanding-orders />
        <div class="mt-20">
            <h2 class="d-inline-block mb-0">Active Orders</h2>
        </div>
        <active-orders :filter="filter" />
        <div class="mt-30">
            <h2 class="mb-0">Closed Orders</h2>
        </div>
        <closed-orders :filter="filter" />
    </vue-scroll>
</template>

<script>
import ActiveOrders from "@/views/pages/corporation-context/order/ActiveOrders";
import ClosedOrders from "@/views/pages/corporation-context/order/ClosedOrders";
import OutstandingOrders from "@/views/pages/corporation-context/order/OutstandingOrders";

export default {
    components: {
        ActiveOrders,
        ClosedOrders,
        OutstandingOrders,
    },
    data() {
        return {
            filter: {
                search: "",
            },
        };
    },
};
</script>

<style scoped></style>
